import React, { useState } from "react";
import Input from "@/components/Input/Input";
import { Button, Modal } from "@mui/material";
import styles from "./EditOptionModal.module.scss";
import addImgIcon from "@/assets/icons/image-upload.svg";
import Textarea from "@/components/Textarea/Textarea";
import { Option } from "@/store/models/books.models";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onEdit: (formData: FormData, optionId: string) => Promise<void>;
  option: Option;
  type: string;
};

export const EditOptionModal = ({
  isOpen,
  setIsOpen,
  onEdit,
  option,
  type,
}: Props) => {
  const [newOptionName, setNewOptionName] = useState(option.optionName);
  const [newOptionDescr, setNewOptionDescr] = useState(option.description);
  const [imgFile, setImgFile] = useState<File | null>(null);
  const [imgPreview, setImgPreview] = useState<string | null>(option.imgUrl);

  const handleFileUpload = (
    e: React.ChangeEvent<HTMLInputElement>,
    fileType: string
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      setImgFile(file);
      setImgPreview(URL.createObjectURL(file));
    }
  };

  const handleSave = () => {
    const imgToSave = imgFile || imgPreview;

    if (!imgToSave) {
      console.error("Please select or keep an existing file.");
      return;
    }

    const formData = new FormData();
    formData.append("optionName", newOptionName);
    formData.append("description", newOptionDescr);

    if (imgFile) {
      formData.append("imgFile", imgFile);
    } else if (typeof imgPreview === "string") {
      formData.append("imgPreview", imgPreview);
    }

    onEdit(formData, option.uid);

    setImgFile(null);
    setImgPreview("");
    setNewOptionDescr("");
    setNewOptionName("");
  };

  return (
    <Modal
      aria-labelledby="modal-edit-option"
      aria-describedby="Edit an option in the system. Enter the new data and click save"
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div className={styles.modalContainer}>
        <h3 className={styles.modalTitle}>Edit Option</h3>
        <Input
          label="Name"
          value={newOptionName}
          onChange={(e) => setNewOptionName(e.target.value)}
        />

        {(type === "Hero" || type === "Villain" || type === "Special item") && (
          <Textarea
            label="Description"
            value={newOptionDescr}
            onChange={(e) => setNewOptionDescr(e.target.value)}
          />
        )}

        <label className={styles.modalAddItem} htmlFor="img" id="dropcontainer">
          <img className={styles.modalImg} src={addImgIcon} alt="img" />
          <input
            id="img"
            type="file"
            accept="image/*"
            onChange={(e) => handleFileUpload(e, "img")}
          />

          <span className={styles.modalPrimaryText}>
            or drag and drop the file here (*.png)
          </span>
        </label>

        {imgPreview && (
          <img
            className={styles.thumbnailPreview}
            src={imgPreview}
            alt="Thumbnail Preview"
            width={100}
            height={100}
          />
        )}

        <div className={styles.btns}>
          <Button
            sx={{
              textTransform: "capitalize",
              height: "44px",
              width: "120px",
              backgroundColor: "#008000",
              borderRadius: "12px",
              "&:hover": {
                backgroundColor: "#008000",
              },
            }}
            variant="contained"
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            sx={{
              textTransform: "capitalize",
              height: "44px",
              width: "120px",
              border: "1px solid #5570F1",
              color: "#5570F1",
              borderRadius: "12px",
            }}
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

